import { Router, type RouteComponentProps } from '@reach/router';

import {
  useHost,
  XingletLoader,
  type XingletLoaderProps,
} from '@xing-com/crate-xinglet';

type ArticlesRouterType = RouteComponentProps<{
  children: JSX.Element;
}> &
  XingletLoaderProps;

const ArticlesXinglet: React.FC<ArticlesRouterType> = (props) => {
  return <XingletLoader {...props} />;
};

/* LOGGED IN */

export type ArticleEditorRoute = {
  id: string;
  path: string;
  exact?: boolean;
};

export const articleEditorRoutes: Array<ArticleEditorRoute> = [
  {
    id: 'default-new-article',
    path: '/edit/new',
    exact: true,
  },
  {
    id: 'insider-new-article',
    path: '/insider/edit/new',
  },
  {
    id: 'insider-new-article',
    path: '/insider/:page_id/edit/new',
  },
  {
    id: 'publisher-page-new-article',
    path: '/page/:page_id/edit/new',
  },
  {
    id: 'edit-article',
    path: '/:article_id/edit',
  },
];

const LoggedInNotFound: React.FC<RouteComponentProps> = () => {
  window.location.href = '/';
  return null;
};

export const LoggedInRouter: React.FC = () => {
  return (
    <Router>
      <ArticlesXinglet name="@xing-com/crate-articles-demo" exact path="demo" />

      {articleEditorRoutes.map(({ id, path, exact }) => (
        <ArticlesXinglet
          key={id}
          path={path}
          exact={exact}
          name="@xing-com/crate-articles-editor"
        />
      ))}

      <ArticlesXinglet name="@xing-com/crate-articles-viewer" path="/:id" />

      <LoggedInNotFound default />
    </Router>
  );
};

/* LOGGED OUT */

const LoggedOutNotFound: React.FC<RouteComponentProps> = () => {
  const { isPreview } = useHost();

  const loginLink = isPreview
    ? 'https://login.preview.xing.com'
    : 'https://login.xing.com/';

  window.location.href = loginLink;
  return null;
};

export const LoggedOutRouter: React.FC = () => {
  return (
    <Router>
      <ArticlesXinglet name="@xing-com/crate-articles-viewer" path=":id" />
      <LoggedOutNotFound default />
    </Router>
  );
};
